/**
 * CUSTOM MOBILE DRAWER MENU (menu_mobile_custom)
 * Fully independent of the theme's default menu_mobile drawer.
 * - Trigger buttons with aria-controls="menu_mobile_custom" open/close the drawer.
 * - Parent menu -> 2-column panel (children left, images right).
 * - Back button returns to parent grid; close button / overlay closes the drawer.
 */
(function () {
  'use strict';

  const drawerSel = '#menu_mobile_custom';
  let drawer = document.querySelector(drawerSel);
  if (!drawer) return;

  const overlay = document.querySelector('[data-menu-custom-overlay]');
  const parents = drawer.querySelector('.hdt-menu-custom__parents');
  const panels = Array.from(drawer.querySelectorAll('[data-menu-custom-panel]'));
  const closeBtn = drawer.querySelector('[data-menu-custom-close]');
  const body = drawer.querySelector('.hdt-menu-custom__body');

  const parentBtns = Array.from(drawer.querySelectorAll('[data-menu-custom-parent]'));

  function open() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hdt-menu-custom--no-scroll');
  }

  function close() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hdt-menu-custom--no-scroll');
    // Reset to parent grid
    panels.forEach((p) => p.classList.remove('is-active'));
    if (parents) parents.style.transform = '';
    parentBtns.forEach((b) => b.classList.remove('hdt-menu-custom__parent--active'));
  }

  function showPanel(key) {
    if (!parents || !panels.length) {
      // No children — just follow the link if it's a direct parent
      const btn = parentBtns.find((b) => b.dataset.panel === key);
      if (btn && btn.dataset.hasChildren !== 'true' && btn.dataset.url) {
        window.location.href = btn.dataset.url;
        return;
      }
      return;
    }
    const activePanel = panels.find((p) => p.dataset.panel === key);
    if (!activePanel) {
      // Fallback: parent has no matching panel (e.g. leaf) — navigate to its url
      const btn = parentBtns.find((b) => b.dataset.panel === key);
      if (btn && btn.dataset.hasChildren !== 'true' && btn.dataset.url) {
        window.location.href = btn.dataset.url;
        return;
      }
      return;
    }
    parents.style.transform = 'translateX(-100%)';
    panels.forEach((p) => p.classList.remove('is-active'));
    activePanel.classList.add('is-active');
    parentBtns.forEach((b) => b.classList.toggle('hdt-menu-custom__parent--active', b.dataset.panel === key));
  }

  function showGrid() {
    if (parents) parents.style.transform = '';
    panels.forEach((p) => p.classList.remove('is-active'));
    parentBtns.forEach((b) => b.classList.remove('hdt-menu-custom__parent--active'));
  }

  // Open/close via all matching triggers
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[aria-controls="menu_mobile_custom"]');
    if (!trigger) return;
    e.preventDefault();
    open();
    // Give the drawer time to finish opening animation before resetting panels
    setTimeout(showGrid, 0);
  });

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);
  if (body) {
    body.addEventListener('click', (e) => {
      const back = e.target.closest('[data-menu-custom-back]');
      if (back) { e.preventDefault(); showGrid(); return; }
      const parent = e.target.closest('[data-menu-custom-parent]');
      if (parent) { e.preventDefault(); showPanel(parent.dataset.panel); return; }
    });
  }

  // Keyboard: close on Esc
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();